import { create } from "zustand";
import { persist } from "zustand/middleware";

import { addItem } from "@/cart/addItem";
import { addItems } from "@/cart/addItems";
import { addDiscountCode } from "@/cart/addDiscountCode";
import { STORAGE_KEY } from "@/cart/consts";
import { initializeCart } from "@/cart/initializeCart";
import { removeItem } from "@/cart/removeItem";
import { replaceItems } from "@/cart/replaceItems";
import type { CartState } from "@/cart/types";
import { updateItem } from "@/cart/updateItem";
import { setCartAndLineAttributes } from "@/cart/setCartAndLineAttributes";
import { stampAttribution } from "@/cart/stampAttribution";
import { ensureReferralCode } from "@/cart/ensureReferralCode";
import { addMatic } from "@/cart/addMatic";
import { addAnnualBagPass } from "@/cart/addAnnualBagPass";
import { addMaticCare } from "@/cart/addMaticCare";
import { addBuilderKit } from "@/cart/addBuilderKit";

const useCart = create<CartState>()(
  persist(
    (set, get) => ({
      cartId: undefined,
      cart: undefined,
      referralCode: undefined,

      initializeCart: initializeCart({ set, get }),
      addItem: addItem({ set, get }),
      addItems: addItems({ set, get }),
      ensureReferralCode: ensureReferralCode({ set, get }),
      addMatic: addMatic({ set, get }),
      addAnnualBagPass: addAnnualBagPass({ set, get }),
      addMaticCare: addMaticCare({ set, get }),
      addBuilderKit: addBuilderKit({ set, get }),
      removeItem: removeItem({ set, get }),
      replaceItems: replaceItems({ set, get }),
      updateItem: updateItem({ set, get }),
      addDiscountCode: addDiscountCode({ set, get }),
      setCartAndLineAttributes: setCartAndLineAttributes({ set, get }),
      stampAttribution: stampAttribution({ set, get }),
      isGift: false,
      setIsGift: (isGift) => set({ isGift }),
    }),
    {
      name: STORAGE_KEY,
      partialize: (s) => ({
        cartId: s.cartId,
      }),
      onRehydrateStorage: () => (state) => {
        state?.initializeCart();
      },
    },
  ),
);

export default useCart;
